import selectors from './selectors';

const handleLangToggle = (event) => {
    const { lang, cell, popup, action } = selectors.table;

    let clicked = $(event.target);
    const parent = clicked.parent();
    const isCell = clicked.is(cell) || parent.is(cell);
    const isToggle = clicked.is(lang.toggle) || parent.is(lang.toggle);
    if (isCell || isToggle) {
        // If clicking the icon in the button.
        if (parent.is(cell) || parent.is(lang.toggle)) {
            clicked = parent;
        }

        // Close panels.
        $(popup).removeClass('active');

        // Open selected panel.
        clicked.siblings(popup).addClass('active');

    } else if (!clicked.is(action)) {
        // If clicked element is not another action in the table, close panels.
        $(popup).removeClass('active');
    }
};

export default handleLangToggle;
